"use strict";
module.exports = class LinkStyleImpl {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/nodes/LinkStyle-impl.js
// module id = YGuy
// module chunks = 0